// Shared form validation helpers.
export const isValidPhone = (v) => /^\+?\d{8,15}$/.test((v || "").trim());
export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim());
export const sanitizePhone = (v) => (v || "").replace(/[^\d+]/g, "").replace(/(?!^)\+/g, "").slice(0, 16);
